module.exports = __webpack_public_path__ + "img/nonum@2x.3a2f5978.png";